// Constant used with work order pages for select of different status
export const RouteStopStatus = [
  { "value" : "C", "label" : "_complete"},
  { "value" : "I", "label" : "_in-progress"},
  { "value" : "X", "label" : "_cancelled"},
  { "value" : "D", "label" : "_delayed"},
  { "value" : "P", "label" : "_pending"}
];
